var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Observer',{on:{"on-change":_vm.onChange}},[_c('ICountUp',{ref:"count",attrs:{"endVal":0,"options":Object.assign({}, _vm.options, {suffix: _vm.unit})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }